import React from "react";
import SVGIcon from "./svgIcon";

interface Props {
  iconId: string;
  title: string;
  text: string;
}

function Service(props: Props) {
  return (
    <div className="service">
      <div className="service__icon">
        <SVGIcon id={props.iconId} />
      </div>
      <h3 className="service__title">{props.title}</h3>
      <p className="service__text">{props.text}</p>
    </div>
  );
}

export default Service;
